import type { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import IconButton from '@mui/material/IconButton';
import { CloseIcon } from '@/icons';
import { classes } from './utils';

interface DialogTitleProps extends PropsWithChildren {
  title?: string;
  subtitle?: string;
  className?: string;
  titleClassName?: string;
  subtitleClassName?: string;
  onClose?: () => void;
}

export default function DialogTitle({
  title,
  subtitle,
  className,
  titleClassName,
  subtitleClassName,
  children,
  onClose,
  ...props
}: DialogTitleProps) {
  const renderTitles = () => {
    return (
      <>
        {title && (
          <h1 className={twMerge(classes.title, titleClassName)}>{title}</h1>
        )}
        {subtitle && (
          <h2 className={twMerge(classes.subtitle, subtitleClassName)}>
            {subtitle}
          </h2>
        )}
      </>
    );
  };
  if (!!onClose) {
    return (
      <div
        className={twMerge(
          classes.titles,
          classes.closeButtonWrapper,
          className
        )}
        {...props}>
        <div className={classes.closeButtonTitles}>{renderTitles()}</div>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
    );
  } else {
    return (
      <div className={twMerge(classes.titles, className)} {...props}>
        {renderTitles()}
      </div>
    );
  }
}
